export default __webpack_public_path__ + "static/media/success.11c6ed92.svg";